const es = {
  // Nav
  nav: {
    home: 'Inicio',
    menu: 'Carta',
    order: 'Pedir',
    gallery: 'Galeria',
    reviews: 'Opiniones',
    reservation: 'Reserva',
    reserve: 'Reservar mesa',
  },

  // Home page
  home: {
    sectionCuisine: 'Nuestra cocina',
    sectionAtmosphere: 'Ambiente',
    sectionFormules: 'Nuestros menus',
    sectionActus: 'Novedades',
    sectionSocial: 'Siguenos',
    sectionExceptions: 'Horarios excepcionales',
    formulesSubtitle: 'Precios que enamoran',
    actusSubtitle: 'Que hay de nuevo?',
    seeGallery: 'Ver la galeria de fotos',
    seeFullMenu: 'Descubrir toda la carta',
    googleRating: '4,1/5 en Google',
    googleRatingValue: '4,1',
    googleReviewsCount: '150 reseñas',
    formulesFrom: 'Menús desde 15 €',
    closed: 'Cerrado',
    burgersCount: 'hamburguesas a elegir',
    callUs: 'Llamarnos',
    directions: 'Como llegar',

    defaultHeroTitle: 'Tu restaurante de barrio en Burdeos',
    defaultHeroSubtitle: 'Cocina sencilla y generosa, terraza sombreada, ambiente acogedor.',
    defaultAboutTitle: 'Sencillo, fresco y generoso',
    defaultAboutText: 'En Cote Terrasse, preparamos una cocina sincera con productos frescos y de temporada.',
    defaultAtmosphereTitle: 'Una terraza con jardin',
    defaultAtmosphereText: 'Disfruta de nuestro comedor con jardin, un autentico remanso de paz en pleno Burdeos.',
    defaultCtaTitle: 'Te apetece venir?',
    defaultCtaText: 'Reserva tu mesa en unos clics o ven a vernos directamente.',
    defaultBtnReserve: 'Reservar mesa',
    defaultBtnMenu: 'Ver la carta',
    defaultBtnCall: 'Llamarnos',
    defaultBtnDirections: 'Como llegar',
  },

  // Reservation
  reservation: {
    sectionLabel: 'Reserva y contacto',
    titleOnline: 'Reserva tu mesa',
    titlePhone: 'Reserva por telefono',
    phoneOnly: 'Reserva solo por telefono',
    phoneDesc: 'Para reservar mesa, llamanos directamente. Nuestro equipo estara encantado de recibirte.',
    callNow: 'Llamar ahora',
    noPhone: 'Numero de telefono no indicado. Contacta con el administrador.',
    formTitle: 'Solicitud de reserva',
    name: 'Nombre',
    phone: 'Telefono',
    email: 'Email',
    date: 'Fecha',
    time: 'Hora',
    guests: 'Comensales',
    guestSingular: 'persona',
    guestPlural: 'personas',
    message: 'Mensaje (opcional)',
    messagePlaceholder: 'Alergias, peticiones especiales...',
    choose: 'Elegir',
    namePlaceholder: 'Tu nombre',
    phonePlaceholder: '+33 6 ...',
    emailPlaceholder: 'tu@email.com',
    submit: 'Enviar solicitud',
    sending: 'Enviando...',
    success: 'Solicitud de reserva enviada! Nos pondremos en contacto contigo pronto.',
    errorDate: 'Por favor, selecciona una fecha',
    errorTime: 'Por favor, selecciona una hora',
    errorGeneric: 'Error al enviar. Por favor, intentalo de nuevo.',
    infoTitle: 'Informacion practica',
    openingHours: 'Horario de apertura',
    closed: 'Cerrado',
  },

  // Gallery
  gallery: {
    sectionLabel: 'Galeria',
    title: 'En imagenes',
    description: 'Descubre nuestra terraza, nuestro comedor con jardin y nuestros platos en fotos.',
    all: 'Todas',
    plats: 'Platos',
    terrasse: 'Terraza',
    salle: 'Comedor',
    ambiance: 'Ambiente',
    empty: 'No hay fotos en esta categoria.',
    lightboxTitle: 'Foto de la galeria',
  },

  // Menu
  menu: {
    sectionLabel: 'Nuestra carta',
    title: 'La Carta',
    description: 'Descubre nuestras hamburguesas caseras, tapas para compartir, y nuestros menus ventajosos. Cocina preparada con productos frescos y de temporada.',
    formules: 'Menus',
    supplements: 'Suplementos:',
    from: 'desde',
    sides: 'Guarniciones',
    sidesIncluded: 'Incluido en el precio de la hamburguesa:',
    sidesIncludedText: 'Patatas fritas frescas o Ensalada de temporada.',
    sidesSupplements: 'Suplementos:',
    sidesSupplementsText: 'Patatas de boniato +3EUR | Bacon +3EUR | Cheddar +2EUR',
    sidesNote: 'Filete ANGUS 100% Pura Ternera Origen Francia 150g — Patatas Fritas frescas al estilo belga con Grasa de Ternera — Magret de Pato del Suroeste de Francia',
  },

  // Reviews
  reviews: {
    sectionLabel: 'Opiniones de clientes',
    title: 'Lo que opinan',
    description: 'Mayoria de opiniones de 4 y 5 estrellas. Nuestros clientes valoran la calidad de nuestra cocina, precios razonables y ambiente acogedor.',
    outOf: 'Mas de 200 opiniones',
  },

  // Legal
  legal: {
    title: 'Aviso legal',
    editor: 'Editor del sitio',
    hosting: 'Alojamiento',
    ip: 'Propiedad intelectual',
    ipText: 'Todo el contenido de este sitio (textos, imagenes, logotipos, fotos) es propiedad exclusiva de Cote Terrasse, salvo indicacion contraria. Queda prohibida toda reproduccion, incluso parcial, sin autorizacion previa.',
    data: 'Datos personales',
    dataText: 'La informacion recogida a traves del formulario de reserva (nombre, email, telefono) se utiliza unicamente para tramitar su solicitud de reserva. De acuerdo con el RGPD, usted tiene derecho de acceso, rectificacion y supresion de sus datos personales.',
    cookies: 'Cookies',
    cookiesText: 'Este sitio utiliza cookies tecnicas necesarias para su correcto funcionamiento. No se utilizan cookies publicitarias ni de seguimiento.',
    privacy: 'Politica de privacidad',
    privacyText: 'Nos comprometemos a proteger su privacidad. Los datos personales que nos facilite nunca se transmiten a terceros. Se conservan durante un periodo maximo de 12 meses.',
    responsibility: 'Responsabilidad',
    responsibilityText: 'Cote Terrasse se esfuerza por ofrecer informacion lo mas precisa posible. Los precios y horarios mostrados pueden sufrir modificaciones sin previo aviso.',
    publishedBy: 'Director de la publicacion',
    phone: 'Telefono',
  },

  // Footer
  footer: {
    description: 'Restaurante acogedor en Burdeos. Cocina de temporada, hamburguesas caseras y una agradable terraza con jardin.',
    navigation: 'Navegacion',
    contact: 'Contacto',
    ourMenu: 'Nuestra Carta',
    customerReviews: 'Opiniones',
    legalNotice: 'Aviso legal',
    legalAndPrivacy: 'Aviso legal y Politica de privacidad',
    admin: 'Administracion',
    copyright: 'Todos los derechos reservados.',
  },

  // Maintenance
  maintenance: {
    comingSoon: 'Volvemos pronto',
    defaultMessage: 'Nuestro sitio web esta en proceso de actualizacion. Gracias por su paciencia.',
    openingHours: 'Horario de apertura',
    closed: 'Cerrado',
    copyright: 'Todos los derechos reservados.',
  },

  // Common
  common: {
    closed: 'Cerrado',
    loading: 'Cargando...',
  },
};

export default es;
